import { createContext, FC, useEffect, useState } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { auth } from "../infrastructure/firebase";
import { useAuthState } from "react-firebase-hooks/auth";

export const AuthContext = createContext({
  uId: "",
  token: "",
});

const AuthProvider: FC = ({ children }) => {
  const [user, isLoading] = useAuthState(auth);
  const [loginState, setLoginState] = useState<
    "success" | "loading" | "failed"
  >("loading");
  const [authContext, setAuthContext] = useState({
    uId: "",
    token: "",
  });
  const location = useLocation();

  useEffect(() => {
    const f = async () => {
      if (user) {
        const token = await user.getIdToken();
        setAuthContext({ uId: user.uid, token });
        setLoginState("success");
      } else if (isLoading) {
        setLoginState("loading");
      } else {
        setLoginState("failed");
      }
    };
    f();
  }, [isLoading, user]);

  if (loginState === "loading") {
    return (
      <div className="has-text-centered ">
        <p className="is-size-5">ロード中です...</p>
      </div>
    );
  }
  if (loginState === "success") {
    return (
      <AuthContext.Provider value={authContext}>
        <Outlet />
      </AuthContext.Provider>
    );
  } else {
    return <Navigate to="/signin" state={{ from: location }} />;
  }
};
export default AuthProvider;
